export default "__VITE_ASSET__e7FC6y6C__"